import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TSelectedSubType, TSelectedType } from './HomePage'

export interface IState {
  isNewVehicle: boolean
  selectedType: TSelectedType
  selectedSubType: TSelectedSubType
  vehicleNumber: string
  journeyType: string
  ptr?: string
}

const initialState: IState = {
  isNewVehicle: false,
  selectedType: 'private',
  selectedSubType: 'car',
  vehicleNumber: '',
  journeyType: 'life',
}

const homePageSlice = createSlice({
  name: 'homePageSlice',
  initialState: initialState,
  reducers: {
    updateIsNewVehicle: (
      state,
      action: PayloadAction<{
        isNewVehicle: boolean
      }>,
    ) => {
      const { isNewVehicle } = action.payload
      state.isNewVehicle = isNewVehicle
    },
    updateSelectedType: (state, action: PayloadAction<TSelectedType>) => {
      state.selectedType = action.payload
    },
    updateJourneyType: (state, action: PayloadAction<string>) => {
      state.journeyType = action.payload
    },
    updateSelectedSubType: (state, action: PayloadAction<TSelectedSubType>) => {
      state.selectedSubType = action.payload
    },
    updateVehicleNumber: (state, action: PayloadAction<string>) => {
      state.vehicleNumber = action.payload
    },
    updatePtr: (state, action: PayloadAction<string>) => {
      state.ptr = action.payload
    },
    updateAllDetails: (state, action: PayloadAction<IState>) => {
      const { vehicleNumber, selectedSubType, selectedType, isNewVehicle } = action.payload
      if (vehicleNumber) {
        state.vehicleNumber = vehicleNumber
      }
      if (selectedSubType) {
        state.selectedSubType = selectedSubType
      }
      if (selectedType) {
        state.selectedType = selectedType
      }
      state.isNewVehicle = isNewVehicle
    },
  },
})

const { reducer } = homePageSlice

const {
  updateIsNewVehicle,
  updateSelectedType,
  updateSelectedSubType,
  updateVehicleNumber,
  updateJourneyType,
  updatePtr,
  updateAllDetails,
} = homePageSlice.actions

export {
  reducer as homePageReducer,
  updateSelectedType,
  updateSelectedSubType,
  updateVehicleNumber,
  updateJourneyType,
  updateIsNewVehicle,
  updatePtr,
  updateAllDetails,
}
